import Link from 'next/link';

import Button from '@/components/ui/components/Button';

const ProgramsComponent = ({ course, onApplyNow }: any) => {
  const courseUrl = course?.course_name?.course_url ?? '';
  const hasPageData = course?.course_name?.page_data && course?.course_name?.page_data.length > 0;

  return (
    <div className="min-w-80 flex-col gap-1 rounded-md border-[0.5px] border-[rgba(51,73,136,0.2)] md:flex ">
      <div
        // href={`/course/${course?.course_url}`}
        className=" border-b border-gray-300 bg-[rgba(51,73,136,0.2)] pb-1 pl-2 text-sm font-semibold text-primary md:text-2xl"
      >
        {course?.course_name?.course_name}
      </div>
      <div className="p-2">
        <div className="mt-2 flex flex-col items-start gap-y-1 sm:flex-row md:mt-0 md:gap-2">
          {/* <div className="flex items-center gap-1 justify-center sm:border-r border-gray-300 pr-3">
          <ApprovedByIcon />
          <span>Approved by :</span> */}
          {/* {courseData?.data?.results?.[0]?.approved_by
            ?.slice(0, 3)
            ?.map((approve: any, index: number) => {
              return (
                <ColoredTag
                  key={index}
                  text={approve?.organisation_name + " "}
                  fontSize="text-xs"
                  textColor="text-white"
                  paddingY="py-1"
                  bgColor="bg-primary"
                />
              );
            })} */}
          {/* </div> */}
        </div>

        <div className="mb-2 grid grid-cols-2 items-center gap-2.5">
          <div className=" ">
            <div className="flex items-center gap-1 text-xxs">
              Course Duration :
              <p className="rounded-md bg-[#D9E8F3] p-1 text-xxs font-medium">{course?.course_duration?.duration}</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <p className="text-xxs font-light">
              {course?.course_label} : <span className="text-xxs  text-[#28B229] ">{course?.course_fee}</span>
            </p>
          </div>
          <div className="flex items-center justify-start gap-x-1 text-sm">
            <span className="whitespace-nowrap text-xxs">Exam Accepted:</span>
            <span className="rounded-md bg-[#D9E8F3] p-1 text-xxs font-medium">
              {course?.exam_accepted[0]?.abbreviation.slice(0, 10)}..
              {course?.exam_accepted?.length >= 2 ? (
                <span className="ml-2 rounded-full bg-yellow-300 px-2 py-0.5 text-gray-600">
                  + {course?.exam_accepted?.length - 1}
                </span>
              ) : (
                <></>
              )}
            </span>
          </div>

          <div className="flex items-center gap-1">
            <p className="text-xxs">Mode : </p>
            <p className="text-xxs">{course?.exam_accepted[0]?.exam_mode?.exam_mode}</p>
          </div>
        </div>
        <div className="flex flex-col justify-between gap-1  md:flex-row">
          <div className="mt-3 flex w-full items-center justify-between  gap-2  md:mt-0    ">
            <Button
              text={'Apply Now'}
              onClick={onApplyNow}
              showHover={false}
              outline
              outlineColor="border-primary"
              textColor="text-primary"
              paddingX="px-1 md:px-2"
              paddingY="py-1"
              // width="w-28 lg:w-36"
              btnClassName="w-full"
              align="text-center"
            />
            <Link
              href={hasPageData ? `/courses/${courseUrl}/course-info` : '#'}
              className="w-full rounded-lg border bg-primary px-2 py-1.5 text-center text-xs text-white shadow-lg lg:text-sm"
            >
              View Course
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramsComponent;
